import { render, staticRenderFns } from "./EzPaymentConfig.vue?vue&type=template&id=7be64424"
import script from "./EzPaymentConfig.js?vue&type=script&lang=js&external"
export * from "./EzPaymentConfig.js?vue&type=script&lang=js&external"
import style0 from "./EzPaymentConfig.vue?vue&type=style&index=0&id=7be64424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports